// @ts-nocheck
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import provincia from '../images/blog1_0.JPG';
import blog1_1 from '../images/blog1_1.JPG';
import blog1_2 from '../images/blog1_2.JPG';
import blog1_3 from '../images/blog1_3.JPG';
import blog1_4 from '../images/blog1_4.JPG';
import blog1_5 from '../images/blog1_5.JPG';
import blog1_6 from '../images/blog1_6.JPG';
import blog1_7 from '../images/blog1_7.JPG';
import blog1_8 from '../images/blog1_8.JPG';
import blog1_9 from '../images/blog1_9.JPG';
import blog1_10 from '../images/blog1_10.JPG';
import blog1_11 from '../images/blog1_11.JPG';
import Section0 from '../components/blogs/section0';
import Section2 from '../components/blogs/section2';
import HeaderBlog from '../components/blogs/headerBlog';
import SubheaderBlog from '../components/blogs/subheaderBlog';
import Section3 from '../components/blogs/section3';
import Section01 from '../components/blogs/section01';

const Blog1 = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-20 ">
        <HeaderBlog text={
          "ЗУСТРІЧ ВЕРТЕПІВ СПІЛЬНОТ МОЛОДІЖНОГО САЛЕЗІЯНСЬКОГО РУХУ"
        } />
        <Section0 photo={provincia} />
        <Section2
          title={""}
          text1={`
В актовому залі спільноти «Сад Боско» при храмі Різдва Пресвятої Богородиці відбулася зустріч вертепів спільнот Молодіжного Салезіянського Руху — подія, яка стала справжнім святом віри, традицій та молодіжної творчості.
            `}
          text2={`
Захід розпочався спільною колядкою «Добрий вечір Тобі» та вступним словом отця Анатолія Гецянина, відповідального за душпастирство молоді Салезіянської Провінції УГКЦ. Подія зібрала численних учасників і гостей, об’єднаних спільним прагненням через мистецтво вертепу прославити таїнство Народження Ісуса Христа.

            `} text3={undefined} />
        <Section0 photo={blog1_1} />
        <Section2
          title={""}
          text1={`
У різдвяному дійстві взяли участь вертепи спільнот: «Сад Боско», «Християнська Душа», «ВіО», «Друзі», «АСІХ», «Благовіщення» та «Зіслання Святого Духа». Кожна спільнота з великою відданістю та творчою майстерністю представила власну постановку, наповнену глибоким духовним змістом, символікою та живими емоціями. Через слово, жест і образ молодь свідчила про радість Різдва та силу християнської спільноти.
            `}
          text2={``} text3={undefined} />
        <Section0 photo={blog1_2} />
        <Section2
          title={
            "За результатами оцінювання всі учасники були нагороджені як знак пошани та вдячності за їхню працю і служіння. Окремі вертепи журі відзначило спеціальними нагородами:"
          }
          text1={
            `
• спільнота «Сад Боско» — за найкращі костюми, що вражали автентичністю та продуманістю;    
        `
          }
          text2={
            `
• спільнота «Благовіщення» — за найкращу постановку, яка вирізнялася цілісністю та сценічною виразністю;
            `
          }
          text3={
            `
• спільнота «Зіслання Святого Духа» — за найкращий сюжет, що глибоко і переконливо передав різдвяне послання.
            `
          }
        />
        <Section0 photo={blog1_3} />
        <Section2
          title={
            ""
          }
          text1={
            `
Особливу атмосферу заходу доповнила музична програма. На сцені виступили гурти: «Друзі», Bosco Band, Soul Band та «Благовіщення». Їхній натхненний спів наповнив зал духом радості, єдності та щирої молитви, ставши органічним продовженням вертепного дійства.
            `
          }
          text2={undefined}
          text3={undefined}
        />
        <Section01 photo1={blog1_4} photo2={blog1_5} />

        <Section2
          title={
            ""
          }
          text1={

            `
Ведучим події був Марко Янів, який професійно та гідно провадив програму заходу. Оцінювання виступів здійснював Олег Кузик.
            `
          }
          text2={undefined}
          text3={undefined}
        />
        <Section3
          photo={blog1_6}
          text={
            "Ідейним натхненником та організатором зустрічі став отець Анатолій разом із командою Молодіжного Салезіянського Руху, які доклали значних зусиль для проведення цього святкового заходу."
          } />
        <Section3
          photo={blog1_7}
          text={"На завершення до учасників і гостей звернувся отець Орест Єлізаров, голова у справах молоді Львівської архиєпархії. У своєму слові він подякував молоді за активне свідчення віри, збереження різдвяних традицій та живу присутність Церкви серед молодого покоління. Також він вручив особливу відзнаку «Глядацька симпатія», яку за результатами голосування отримала спільнота «Благовіщення». "
          } />
        <Section2
          title={""}
          text1={"Після офіційної частини всі учасники мали нагоду продовжити спілкування у дружній та родинній атмосфері, почастувавшись смачною випічкою від кондитерки Центру Боско, що стало приємним завершенням цього святкового і духовно насиченого дня."
            }
          text2={"Окрема подяка отцю Оресту Фредині, пароху храму, за теплий прийом та можливість провести цю молодіжну зустріч у приміщенні храму."}
          text3={undefined}
        />
        <Section01 photo1={blog1_8} photo2={blog1_9} />
        <Section01 photo1={blog1_10} photo2={blog1_11} />
        <div className="flex justify-between py-10 italic font-semibold">
          <div>Автор статті: Олена Машталяр</div>
          <div>10.01.2026 р.</div>
        </div>
      </div>
    </>
  );
};

export default Blog1;
